
import React from "react";
import { useNavigate, useParams } from "react-router-dom";

import { Box, Chip, CircularProgress, Grid, Typography, CardActionArea, useTheme, alpha } from "@mui/material";
import { useDistribucionXLote } from "../../../hooks";
import { DisenioLote } from "../../layout";
import { separadorMillares } from "../../../helpers";
import { AlertConIconTitulo, CargandoMedio } from "../../components";
import { iconos } from "../../../data";






const CountCircularProgress = ({ value, actual, original }) => {
    const theme = useTheme();
    const color = value >= 90 ? theme.palette.success.main : 
                  value >= 70 ? theme.palette.warning.main : 
                  theme.palette.error.main;
  
    return (
        <Box sx={{ position:'relative', display:'inline-flex', mb:1, mt:1 }}>

          <CircularProgress variant="determinate" value={100} size={100} thickness={4} 
              sx={{ color: alpha(theme.palette.divider, 0.3) }}
          />
          <CircularProgress size={100} variant="determinate" value={value} 
              sx={{ color, position: 'absolute', left: 0 }} thickness={4}
          />
          
          <Box sx={{ position:'absolute', top:0, left:0, bottom:0, right:0, display:'flex', 
              flexDirection:'column', alignItems:'center', justifyContent:'center',
          }}>
            <Typography variant="h5" fontWeight="bold" color={color}>
              {separadorMillares(actual)}
            </Typography>
            <Typography variant="caption" color="text.secondary" sx={{ fontSize: '0.75rem' }}>
              de {separadorMillares(original)}
            </Typography>
          </Box>
        </Box>
    );
};




const WarehouseCard = ({ data }) => {

  const theme = useTheme();
  const navigate = useNavigate();
  const percentageRemaining = Math.max(0, Math.min(100, 100 - (data.descuentos * 100 / data.cantidad)));


  const handleTotalDetalles = (dis) => {
    navigate(`/admin/detalles/${ dis.id }/distri`)
  }



  return (
      <CardActionArea sx={(theme) => ({ height: '100%', borderRadius: 2, border:`2px solid ${theme.palette.secondary.main}`})}
        onClick={ () => handleTotalDetalles(data) }
      >
        <Box sx={{ p:2.5, height:'100%', display:'flex', flexDirection:'column' }}>
            <Box sx={{display:'flex', justifyContent:'center', mb:1.5, pb:1.5, 
                borderBottom: `1px solid ${theme.palette.primary.main}`
            }}>
                <Typography variant="h3" fontWeight="600" color="primary">GALPÓN {data.galpon.nombre}</Typography>
            </Box>
          
            <Box sx={{display:'flex', flexDirection:'column', alignItems:'center',
              flexGrow:1, justifyContent:'center', py: 1 
            }}>
              <Typography variant="subtitle2" color="text.secondary">Cantidad Real</Typography>
              
                <CountCircularProgress value={percentageRemaining} 
                    actual={data.cantidad - data.descuentos} original={data.cantidad}
                />
            </Box>
          
            <Box sx={{pt:1.5, mt:1, borderTop:`1px solid ${theme.palette.primary.main}`,
                display: 'flex', justifyContent:'space-between', alignItems:'center'
            }}>
                <Chip size="small" icon={iconos['sexo']} label={data.genero}
                    variant="outlined" color="primary" sx={{borderRadius:'4px', height:28}}
                />
                
                {data.descuentos > 0 && (
                  <Chip size="small" icon={iconos['faltante']} color="secondary"
                      sx={{ height:28, fontWeight:500 }} label={separadorMillares(data.descuentos)}
                />)}
            </Box>
        </Box>
      </CardActionArea>
  );
};





export const DistribucionLote = () => {

    const { id } = useParams();
    const { distribucionXLoteQuery } = useDistribucionXLote(id);
    

    return (

        <DisenioLote titulo="Distribución de Lote" url={1}>
            {(distribucionXLoteQuery.isLoading)
            ?   <CargandoMedio titulo="Cargando Distribución" />
            :   (!distribucionXLoteQuery?.data || distribucionXLoteQuery?.data.length === 0)
            ?   <AlertConIconTitulo icono="granja" titulo="No hay datos disponibles"
                  subtitulo="No se encontró información de distribución para este lote"
                />
            :   <Grid container spacing={3}>
                  {distribucionXLoteQuery.data.map( (dis, index) => (
                      <Grid item md={4} sm={6} xs={12} key={dis.id || index}>
                          <WarehouseCard data={dis} index={index} />
                      </Grid>
                  ))}
                </Grid>
            }
        </DisenioLote>
    );
};

